import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
  SET_HEADLINE: "SET_HEADLINE",
  GENERAL_HEADLINE_REQUEST: "GENERAL_HEADLINE_REQUEST",
  GENERAL_HEADLINE_SUCCESS: "GENERAL_HEADLINE_SUCCESS",
  GENERAL_HEADLINE_ERROR: "GENERAL_HEADLINE_ERROR"
}

export const setHeadline = (profile) => {
  return {
    type: actions.SET_HEADLINE,
    personId: profile.id,
    body: profile.profile_common.headline
  }
}

export const headlineApiCall = (personId, payload, type, callback) => {
  const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : type );

  return (dispatch) => {
    dispatch({
      type: actions.GENERAL_HEADLINE_REQUEST,
      isHeadlineFetching: true,
      isHeadlineError: false
    })
    requestHelpers
      .authenticatedPostRequest(`/profiles/${ personId }/headline`, payload, requestType)
      .then((response) => {
        callback();
        return dispatch({
          type: actions.GENERAL_HEADLINE_SUCCESS,
          personId: personId,
          body: payload && payload.headline,
          isHeadlineFetching: false,
          isHeadlineError: false
        })
      }).catch((error) => {
        callback(error);
      })
    dispatch(updateTodoList(personId, 8));
  }
}





// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/headline.js